import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticsItem, AnalyticsTransaction } from './interface';

declare let window: any;

@Injectable()
export class GoogleAnalyticsService {
  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (window.ga) {
          window.ga('set', 'page', event.urlAfterRedirects);
          window.ga('send', 'pageview');
        }
      }
    });
  }

  initialize(property: string, dimensions: string[]): void {
    if (property !== '') {
      this.appendGaTrackingCode(property, dimensions);
      this.loadEnhancedEcommerce();
    }
  }

  private appendGaTrackingCode(property: string, dimensions: string[]): void {
    const script = document.createElement('script');
    let analytics =
      `
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        ga('create', '` +
      property +
      `', 'auto');`;
    dimensions.forEach((dimension: string, index: number) => {
      analytics += `ga('set', 'dimension` + (index + 1) + `', '` + dimension + `');`;
    });
    script.innerHTML = analytics;
    document.head.appendChild(script);
  }

  private loadEnhancedEcommerce(): void {
    window.ga('require', 'ec');
  }

  trackEvent(event: string, action: string, label: string): void {
    window.ga('send', 'event', event, action, label);
  }

  // See https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#transaction for ecommerce info
  startEcommerceTransaction(transaction: AnalyticsTransaction): void {
    window.ga('ec:setAction', 'purchase', {
      id: transaction.transactionId,
      affiliation: transaction.affiliation,
      revenue: transaction.revenue,
      currency: transaction.currency,
    });
  }

  addEcommerceItem(item: AnalyticsItem): void {
    window.ga('ec:addProduct', {
      id: item.id,
      name: item.name,
      category: item.category,
      price: String(item.price / 100),
      quantity: item.quantity,
      currency: item.currency,
    });
  }

  // send ecommerce transaction and items to analytics
  sendEcommerceEvent(action: 'Checkout', label?: string): void {
    this.trackEvent('Ecommerce', action, label || '');
  }
}
